import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VisibilityService } from '../shared/services/visibility.service';
import { HomeService } from '../shared/services/home.service';
import { LoginService } from '../services/login.service';
import { DialogService } from '../shared/services/dialog-service';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../shared/dialog/modal/modal.component';
import { PanelListService } from '../shared/services/panel-list.service';
import { NotifierService } from 'angular-notifier';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';

interface Control{
  name:string;
  value:boolean;
  subControls:SubControl[];
  optionalControl?:SubControl[];
  subHeaders?: {name:string, value:boolean, type:string}[];
  disable?:boolean
  hidden?:boolean
}
interface SubControl{
  name:string;
  value:boolean;
  default:boolean;
  hours?:number;
  type?: string;
  key?: string;
  subControls?: SubControl[];
}
interface Delays{
  delay:boolean;
  delayCount:boolean;
}
interface Element{
  els?:any;
  show:boolean;
}

interface VisibilityData{
  performaceTracker:Element;
  analysisReport:Element;
  panelList:any;
  imageSearch:any;
  trueFace:any;
  delays:Delays;
}


@Component({
  selector: 'app-visibility-control',
  templateUrl: './visibility-control.component.html',
  styleUrls: ['./visibility-control.component.scss']
})
export class VisibilityControlComponent implements OnInit {

  controls:Control[] = [];
  defaultControls:SubControl[] = [];
  newdefaultControls:Control[] = [];
  public scheduleRawDataObj:any = {};
  accessRules:any;

  getVisibilityData:any;
  visibilityData:VisibilityData;
  studyId:string;
  errorText:string;
  isLoading:boolean = false;
  isOpen:boolean = false;
  isError:boolean = false;
  rootProjectName:string="";
  rootProjectUrl : string="";
  performaceTrackerData:any=[];
  accessRoles:any=[];
  detailsNameFull:string;
  detailsName:string="";
  scheduleDatahoursCont = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23];
  scheduleDataminutesCont = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59];
  schedulerepeatType = ['Daily','Weekly','Monthly','Hourly','every_6_hour','every_12_hour'];
  scheduleRawDataEmailContainer:any = [];
  copyscheduleRawDataEmailContainer:any = [];

  constructor(
    private activeRoute:ActivatedRoute, 
    private visibilityService: VisibilityService,
    private homeService: HomeService,
    private logerror:LoginService,
    private router: Router,
    private dialogService:DialogService,
    private dialog: MatDialog,
    private panelService: PanelListService,
    private notifier:NotifierService,
    private sidePanelService:SidePanelService
    ) { 
      this.homeService.isOpen = true;
      this.assignControlsData(); // this set default controls value
      this.dialogService.isData = 'wentWrong';
      this.dialogService.confirmMsg = 'something went wrong';
      this.scheduleRawDataObj = {
        start_date:"",
        end_date:"",
        month_date:'',
        week_day:'1',
        repeat_type:'Daily',
        timeSlot:[{"hours":"","minutes":""}],
        sendTo:[]
      };
    }

  ngOnInit() {
    this.assignVisibility();
    this.visibilityData = this.getVisibilityData;
    this.activeRoute.params.subscribe((params) => {
      this.studyId = params['id'];
      // localStorage.setItem('studyId',this.studyId);
      sessionStorage.setItem('studyId',this.studyId);
    });
    this.getVisibilityStudy();
    this.getResponseDataQuota();
    this.getEmailUserForSchedule();
    this.getSupersetDashboardStudyWise();
    this.setSidePanelVisbility();
  }

  getSupersetDashboardStudyWise(){
    this.visibilityService.getStudyWiseSupersetDashboard(this.studyId, {}).subscribe((res)=>{
      if(res && res.status && res.data && res.data.length > 0){
        this.addSuperSetToNewDefaultControls(res.data);
      }
    });
  }


  addSuperSetToNewDefaultControls(data:any){
    let new_control = {name:'Superset Dashboard',value:false,subControls:[]};
    data.forEach((item)=>{
      new_control.subControls.push(
        {name:item.heading, uuid:item.uuid, type:'radio', value:false, default:false,key: item.perm,desc:item.desc});
    });
    this.newdefaultControls.push(new_control);

    // Apply saved visibility values if already loaded
    if(this.getVisibilityData?.superset){
      new_control.value = this.getVisibilityData['superset']['show'] || false;
      let supersetEls = this.getVisibilityData['superset']['els'];
      if(supersetEls && Object.keys(supersetEls).length > 0){
        new_control.subControls.forEach((sub: any) => {
          if(supersetEls[sub.key]){
            sub.value = supersetEls[sub.key].show || false;
          }
        });
      }
    }
  }

  selectValue(value:any){
    this.controls[0]['optionalControl'][0].value = value;
  }

  openDialogConfirm(): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '400px',
      height: '186px'
    });
  }


  getEmailUserForSchedule(){
    this.panelService.getEmailUserForSchedule(this.studyId).subscribe((data)=>{
      if(data && data.status === 1){
        this.scheduleRawDataEmailContainer = data.result || [];
        this.copyscheduleRawDataEmailContainer = data.result || [];
      }
      
    });

  }

  onScheduleRawDataEmailSearch(event){
    let val = event.target.value;
    if(val.length >= 3){
      let filterEmail = this.copyscheduleRawDataEmailContainer.filter((email)=> email.toLowerCase().includes(val.toLowerCase()));
      let selectedEmail = this.copyscheduleRawDataEmailContainer.filter((email)=> this.scheduleRawDataObj.sendTo.includes(email));  
      this.scheduleRawDataEmailContainer = [...filterEmail,...selectedEmail];
    }else{
      this.scheduleRawDataEmailContainer = this.copyscheduleRawDataEmailContainer;
    }

  }

  addSendTo(email){
    if(this.scheduleRawDataObj.sendTo.indexOf(email) === -1){
      this.scheduleRawDataObj.sendTo.push(email);
    }
  }
  
  toggleControl(controlName:string, index:string,subControls?:any){
    if(this.controls[index] && this.controls[index]['name'] === controlName){
      this.controls[index]['value'] = !this.controls[index]['value'];
        this.defaultVisible(this.controls[index]['subControls'], this.controls[index]['value']);
        if(controlName === 'Report (RLD / SPSS)'){
          this.controls[0]['optionalControl'][0].value = this.controls[index].value? true : false;
        }

    }else if(this.defaultControls[index] && this.defaultControls[index]['name'] === controlName){
      this.defaultControls[index]['value'] = !this.defaultControls[index]['value'];

    }else{
      subControls['value'] = !subControls['value'];
      // this.controls[index]['subControls'].find((prop)=>{
      //    if(prop.name === controlName){
      //      prop.value = !prop.value;
      //    }
      // });
    }
  }

  toggleSubheaderControl(subHeaderName: string, subIdx: number, index: number) {
    if (this.controls[subIdx]['subHeaders'][index] && this.controls[subIdx]['subHeaders'][index]['name'] === subHeaderName) {
      this.controls[subIdx]['subHeaders'][index]['value'] = !this.controls[subIdx]['subHeaders'][index]['value'];
    }
  }

  toggleSubControl(indexes: number[], isOnlySelect: boolean) {
    let current: any = this.controls;

    for (let i = 0; i < indexes.length; i++) {
      const index = indexes[i];
      
      if (current[index] === undefined) {
        console.error(`Invalid index path: ${indexes.slice(0, i + 1).join(' -> ')}`);
        return;
      }
      
      if (i === indexes.length - 1) {
        if (isOnlySelect) {
          current = current.map((sub: SubControl, idx: number) => {
            sub.value = idx === index ? !sub.value : false;
            return sub;
          });
        } else {
          current[index].value = !current[index].value;
        }
      } else {
        current = current[index]['subControls'];
      }
    }
  }

  defaultVisible(subControls:SubControl[], operation:boolean){
    if(operation === false){
      subControls.forEach((control)=>{
        control.value = false;
      });
    }else{
      subControls.forEach((control)=>{
        if(control.default){
          control.value = true;
        }else{
          control.value = false;
        }
      });
    }
  }

  

  submitControlData(){
    // console.log("newdefaultControls ===>",this.newdefaultControls);
    const access = JSON.parse(localStorage.getItem('access'));
    if(access['access_rules'] && access['access_rules']['study'] && access['access_rules']['study']['visibility_control'] && access['access_rules']['study']['visibility_control']['update']){
      this.isSheduleRLDCheckon();
    }else{
      this.notifier.notify('error','Access Denied');
    }
  }

  // dateFilter = (date: Date | null): boolean => {
  //   const currentDate = new Date();
  //   if (date) {
  //     return date.getMonth() === currentDate.getMonth() && date.getFullYear() === currentDate.getFullYear();
  //   }
  //   return false;
  // };

  isSheduleRLDCheckon(){
    let isScheduleRLD = this.controls.find((control)=> control.name === 'Schedule Raw data (RLD)');
    if(isScheduleRLD.value){
      let isTimeSlotEmpty = this.scheduleRawDataObj.timeSlot.find((time)=> time.hours === '' || time.minutes === '');
      let repeat_type = this.scheduleRawDataObj.repeat_type;
      let current_date = new Date().toLocaleDateString('en-CA');
      let startDate = new Date(this.scheduleRawDataObj.start_date).toLocaleDateString('en-CA');
      let endDate = new Date(this.scheduleRawDataObj.end_date).toLocaleDateString('en-CA');
      this.scheduleRawDataObj.start_date = startDate;
      this.scheduleRawDataObj.end_date = endDate;
      let oneYearLater:any = new Date(startDate);
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
      oneYearLater = oneYearLater.toLocaleDateString('en-CA');
      

      if(!this.scheduleRawDataObj.start_date){
        this.notifier.notify('error','Please fill the start date');
        return;
      }

      if(!this.scheduleRawDataObj.end_date){
        this.notifier.notify('error','Please fill the end date');
        return;
      }

      if(isTimeSlotEmpty){
        this.notifier.notify('error','Please fill the time slot');
        return;
      }
      if(!this.scheduleRawDataObj.sendTo.length){
        this.notifier.notify('error','Please select the send to email');
        return;
      }

      if(startDate > current_date){
        this.notifier.notify('error','Start date should be less than current date');
        return;
      }

      if(endDate < current_date){
        this.notifier.notify('error','End date should be greater than current date');
        return;
      }

      if(endDate < startDate){
        this.notifier.notify('error','End date should be greater than start date');
        return;
      }

      if (endDate > oneYearLater) {
        this.notifier.notify('error', 'The gap between start date and end date should not be more than one year');
        return;
      }

      if(repeat_type == 'Weekly' && !this.scheduleRawDataObj.week_day){
        this.notifier.notify('error','Please fill the week day');
        return;
      }
      if(repeat_type == 'Monthly' && !this.scheduleRawDataObj.month_date){
        this.notifier.notify('error','Please fill the month date');
        return;
      }
      else{
        if(this.scheduleRawDataObj.repeat_type == 'Weekly'){
          delete this.scheduleRawDataObj.month_date;
        }
        if(this.scheduleRawDataObj.repeat_type == 'Monthly'){
          let month_date = new Date(this.scheduleRawDataObj.month_date).toLocaleDateString('en-CA');
          this.scheduleRawDataObj.month_date = month_date;
          delete this.scheduleRawDataObj.week_day;
        }
        if(this.scheduleRawDataObj.repeat_type != 'Weekly' && this.scheduleRawDataObj.repeat_type != 'Monthly'){
          delete this.scheduleRawDataObj.week_day;
          delete this.scheduleRawDataObj.month_date;
        }
      }
    }
    if(this.getVisibilityData){
      this.setControls();
    }
    this.setVisibilityStudy();
    
  }

 



  setSidePanelVisbility(){
    this.sidePanelService.getVisibility(this.studyId);
  }

  getVisibilityStudy(){
    this.isLoading = true;
    this.visibilityService.getStudyVisiblity(this.studyId).subscribe((data)=>{
      if(data.status === 1){
        if(data.data){
          let parsedData = data.data;
          try {
            while (typeof parsedData === "string") {
              parsedData = JSON.parse(parsedData);
            }
            this.getVisibilityData = parsedData;
          } catch (e) {
            this.getVisibilityData = null;
          }
          if(Object.keys(this.getVisibilityData).length === 1 && this.getVisibilityData.hasOwnProperty('superset')){
            let data = this.getVisibilityData['superset'];
            this.getVisibilityData = {};
            this.assignVisibility();
            this.getVisibilityData['superset'] = data;
          }
          this.initControls();
        }else {
          this.assignVisibility();
          this.assignControlsData();
        }
        
        this.isError = false;
        this.isOpen = false;
        this.isLoading = false;

      }else{
        this.dialogService.isData = 'wentWrong';
        this.dialogService.confirmMsg = 'something went wrong';
        // this.openDialogConfirm();
        this.isOpen = true;
        this.isLoading = false;
      }
    },(error)=>{
      if (error.status === 401) {
        this.errorText = 'User is not authorised';
        this.isError = true;
        this.isLoading = false;
        this.router.navigate(['home/access-denied']);
      }else {
        this.dialogService.isData = 'wentWrong';
        this.dialogService.confirmMsg = 'something went wrong';
        // this.openDialogConfirm();
        this.isOpen = true;
        this.isLoading = false;
      }
      // this.errorText = "Something Went Wrong";
    });
  }
  setVisibilityStudy(){
    // console.log("setVisibilityStudy getVisibilityData ===>",this.getVisibilityData);
    this.isLoading = true;
    this.visibilityService.setStudyVisiblity(this.studyId, this.getVisibilityData).subscribe((data)=>{
      if(data.status === 1){
        this.dialogService.isData = 'wentWrong';
        this.dialogService.confirmMsg = 'Saved Successfully';
        this.openDialogConfirm();
        this.isError = false;
        this.isOpen = false;
        this.isLoading = false;
        // Invalidate cache and force refresh visibility data after save
        this.sidePanelService.invalidateVisibilityCache(this.studyId);
        this.sidePanelService.getVisibility(this.studyId, undefined, true);
        this.sidePanelService.initSideDrawer(localStorage.getItem('studyTYPE'));
        this.homeService.checkRepoDetailsEvent.emit(this.studyId);
        // this.sidePanelService.initSideDrawer(sessionStorage.getItem('studyTYPE'));
        // this.sidePanelService.initSideDrawer('home');
      }else{
        this.dialogService.isData = 'wentWrong';
        this.dialogService.confirmMsg = 'something went wrong';
        this.openDialogConfirm();
        this.isOpen = true;
        this.isLoading = false;
      }
    },(error)=>{
      if (error.status === 403) {
        this.router.navigate(['home/access-denied']);
      }else if (error.status === 401) {
        this.errorText = 'User is not authorised';
        this.isError = true;
        this.isLoading = false;
        this.router.navigate(['home/access-denied']);
      }else {
        this.dialogService.isData = 'wentWrong';
        this.dialogService.confirmMsg = 'something went wrong';
        this.openDialogConfirm();
        this.isOpen = true;
        this.isLoading = false;
      }
    });
  }

  assignControlsData(){
    // New Code Miraj Default Control
    this.newdefaultControls = [
      {name:'Report View',value:false,subControls:[
        {name:'Funnel (beta)', type:"radio", value:false,default:false},
        {name:'Utm (beta)', type:"radio", value:false,default:false},
        {name:'Term (beta)', type:"radio", value:false,default:false},
        {name:'BI Report', type:"radio", value:false,default:false},
      ]},
      {name:'Survey Properties',value:false,subControls:[
        {name:'Survey Builder', type:"radio", value:false,default:false},
        {name:'Dairy Survey', type:"radio", value:false,default:false},
        {name:'Survey Preview', type:"radio", value:false,default:false},
      ]},
      {name:'Miscellaneous',value:false,subControls:[
        {name:'Panel List', type:"radio",value:false,default:false},
        {name:'Bill Analysis', type:"radio", value:false,default:false},
        {name:'Image Search Panel', type:"radio",value:false,default:false},
        {name:'Analysis Report', type:"radio",value:false,default:false},
        {name:'TrueFace Study', type:"radio",value:false,default:false},
      ]},
    ];

    this.controls = [
      { 
        name:'Performance Tracker', value:false, subControls:[
          {name:'Average Response/ Day', value:true, default:true},
          {name:'Drop Off', value:false, default:false},
          {name:'Terminations', value:false, default:false},
          {name:'Responses', value:true, default:true},
          {name:'Days Left', value:true, default:true},
          {name:'Quota Count', value:false, default:false},
          {name:'Quotas', value:false, default:false},
          {name:'Response Rate Graph', value:false, default:false},
          {name:'Incidence Rate', value:true, default:true},
          {name:'Required Response Rate', value:true, default:true},
        ],
        optionalControl:[
          {name:'Delayed', value:true, default:true, hours:2},
        ]
      },
      {name:'Funnel Report',value:false,subControls:[],disable:true},
      {name:'Quota Report',value:false,subControls:[]},
      {name:'Spss Report',value:false,subControls:[], disable: true, hidden: true},
      { 
        name:'Report (RLD / SPSS)', value:false, subHeaders: [{ name: 'RLD', value: true, type: 'checkbox' }, { name: 'SPSS', value: false, type: 'checkbox' }], subControls:[
          {name:'Company Data', value:false, default:false},
          {name:'Include Concept Question', value:false, default:false},
          {name:'Phone Number', value:false, default:false},
          {name:'Weblink', value:false, default:false},
          {name:'Survey Dates', value:false, default:false},
          {name:'Geo Location', value:false, default:false},
          {name:'Recruiter Id', value:false, default:false},
          {name:'Age', value:false, default:false},
          {name:'City', value:false, default:false},
          {name:'Gender', value:false, default:false},
          {name:'SEC', value:false, default:false},
          {name:'UTM', value:false, default:false},
          {name:'IP', value:false, default:false},
          {name:'Report Type', type: "header", value:false, default:false, subControls: [
            {name:'Default', value:false, default:false, key: 'default'},
            {name:'Binary', value:false, default:false, key: 'binary'},
            {name:'Coded', value:false, default:false, key: 'coded'},
          ]},
          {name:'Completed Responses', type: "header", value:false, default:false, subControls: [
            {name:'Only Completed', value:false, default:false},
            {name:'All Completed', value:false, default:false},
          ]},
        ]
      },
      {name:'Schedule Raw data (RLD)',value:false,subControls:[]},
      {name:'Includes Open Ends',value:false,subControls:[]},
    ];

    // console.log("this.controls default ===>",this.controls);
    // console.log("this.newdefaultControls default ===>",this.newdefaultControls);
  }

 

  // initilize Controls to add controls value from "getStudyVisibility" request
  initControls(){
    if(this.getVisibilityData){
      if(this.getVisibilityData['performaceTracker']){
        // Performance Tracker
        this.controls[0].value = this.getVisibilityData['performaceTracker']['show'] || false;
  
        if(this.getVisibilityData['delays']){
          // Performance Tracker Optional Control 
          this.controls[0]['optionalControl'][0].value = this.getVisibilityData['delays']['delay'] || false;
          this.controls[0]['optionalControl'][0].hours = this.getVisibilityData['delays']['delayCount'] || 0; 
        }
  
        if(this.getVisibilityData['performaceTracker']['els']){
          // Performance Tracker Sub Control
          this.controls[0]['subControls'][0].value = this.getVisibilityData['performaceTracker']['els']['avgResponse'] || false;
          this.controls[0]['subControls'][1].value = this.getVisibilityData['performaceTracker']['els']['dropOff'] || false;
          this.controls[0]['subControls'][2].value = this.getVisibilityData['performaceTracker']['els']['terminations'] || false;
          this.controls[0]['subControls'][3].value = this.getVisibilityData['performaceTracker']['els']['responses'] || false;
          this.controls[0]['subControls'][4].value = this.getVisibilityData['performaceTracker']['els']['daysLeft'] || false;
          this.controls[0]['subControls'][5].value = this.getVisibilityData['performaceTracker']['els']['quotaCount'] || false;
          this.controls[0]['subControls'][6].value = this.getVisibilityData['performaceTracker']['els']['quotas'] || false;
          this.controls[0]['subControls'][7].value = this.getVisibilityData['performaceTracker']['els']['resRateGraph'] || false;
          this.controls[0]['subControls'][8].value = this.getVisibilityData['performaceTracker']['els']['incidenceRate'] || false;
          this.controls[0]['subControls'][9].value = this.getVisibilityData['performaceTracker']['els']['reqResponse'] || false;
          // this.controls[0]['subControls'][10].value = this.getVisibilityData['performaceTracker']['els']['medianLoi'] || false;
          // this.controls[0]['subControls'][11].value = this.getVisibilityData['performaceTracker']['els']['averageLoi'] || false;
        }
      }

      if(this.getVisibilityData['analysisReport'] && this.getVisibilityData['analysisReport']['els']){
        //Download Report
        this.controls[4].value = this.getVisibilityData['analysisReport']['els']['downloadReport'] || false;
        this.controls[4]['subHeaders'][0].value = this.getVisibilityData['analysisReport']['els']['rldReport'] || false;
        this.controls[4]['subHeaders'][1].value = this.getVisibilityData['analysisReport']['els']['spssReport'] || false;
        if(!this.controls[4]['subHeaders'][0].value && !this.controls[4]['subHeaders'][1].value){
          this.controls[4]['subHeaders'][0].value = true;
        }
        if(this.getVisibilityData['analysisReport']['els']['defaults']){
          //Download Report Sub Controls
          // this.controls[4]['subControls'][0].value = this.getVisibilityData['analysisReport']['els']['defaults']['company_data'] || false;
          // this.controls[4]['subControls'][1].value = this.getVisibilityData['analysisReport']['els']['defaults']['phone_number'] || false;
          // this.controls[4]['subControls'][2].value = this.getVisibilityData['analysisReport']['els']['defaults']['weblink'] || false;
          // this.controls[4]['subControls'][3].value = this.getVisibilityData['analysisReport']['els']['defaults']['survey_dates'] || false;
          // this.controls[4]['subControls'][4].value = this.getVisibilityData['analysisReport']['els']['defaults']['geo_location'] || false;
          // this.controls[4]['subControls'][5].value = this.getVisibilityData['analysisReport']['els']['defaults']['recruiter'] || false;
          // this.controls[4]['subControls'][6].value = this.getVisibilityData['analysisReport']['els']['defaults']['age'] || false;
          // this.controls[4]['subControls'][7].value = this.getVisibilityData['analysisReport']['els']['defaults']['city'] || false;
          // this.controls[4]['subControls'][8].value = this.getVisibilityData['analysisReport']['els']['defaults']['gender'] || false;
          // this.controls[4]['subControls'][9].value = this.getVisibilityData['analysisReport']['els']['defaults']['sec'] || false;
          // this.controls[4]['subControls'][10].value = this.getVisibilityData['analysisReport']['els']['defaults']['UTM'] || false;
          // this.controls[4]['subControls'][11].value = this.getVisibilityData['analysisReport']['els']['defaults']['ip'] || false;
          // let isReportTypeIdx = this.controls[4]['subControls'][12]['subControls'].findIndex(sub=> sub.key === this.getVisibilityData['analysisReport']['els']['defaults']['alter_report_type']);
          // if(this.controls[4]['subControls'][12]['subControls'][isReportTypeIdx]) this.controls[4]['subControls'][12]['subControls'][isReportTypeIdx].value = true;

          // this.controls[4]['subControls'][13]['subControls'][0].value = this.getVisibilityData['analysisReport']['els']['defaults']['completed_responses_only'] || false;
          // this.controls[4]['subControls'][13]['subControls'][1].value = this.getVisibilityData['analysisReport']['els']['defaults']['completed_responses_all'] || false;


          this.controls[4]['subControls'][0].value = this.getVisibilityData['analysisReport']['els']['defaults']['company_data'] || false;
          this.controls[4]['subControls'][1].value = this.getVisibilityData['analysisReport']['els']['defaults']['include_concept_headers'] || false;
          this.controls[4]['subControls'][2].value = this.getVisibilityData['analysisReport']['els']['defaults']['phone_number'] || false;
          this.controls[4]['subControls'][3].value = this.getVisibilityData['analysisReport']['els']['defaults']['weblink'] || false;
          this.controls[4]['subControls'][4].value = this.getVisibilityData['analysisReport']['els']['defaults']['survey_dates'] || false;
          this.controls[4]['subControls'][5].value = this.getVisibilityData['analysisReport']['els']['defaults']['geo_location'] || false;
          this.controls[4]['subControls'][6].value = this.getVisibilityData['analysisReport']['els']['defaults']['recruiter'] || false;
          this.controls[4]['subControls'][7].value = this.getVisibilityData['analysisReport']['els']['defaults']['age'] || false;
          this.controls[4]['subControls'][8].value = this.getVisibilityData['analysisReport']['els']['defaults']['city'] || false;
          this.controls[4]['subControls'][9].value = this.getVisibilityData['analysisReport']['els']['defaults']['gender'] || false;
          this.controls[4]['subControls'][10].value = this.getVisibilityData['analysisReport']['els']['defaults']['sec'] || false;
          this.controls[4]['subControls'][11].value = this.getVisibilityData['analysisReport']['els']['defaults']['UTM'] || false;
          this.controls[4]['subControls'][12].value = this.getVisibilityData['analysisReport']['els']['defaults']['ip'] || false;
          let isReportTypeIdx = this.controls[4]['subControls'][13]['subControls'].findIndex(sub=> sub.key === this.getVisibilityData['analysisReport']['els']['defaults']['alter_report_type']);
          if(this.controls[4]['subControls'][13]['subControls'][isReportTypeIdx]) this.controls[4]['subControls'][13]['subControls'][isReportTypeIdx].value = true;

          this.controls[4]['subControls'][14]['subControls'][0].value = this.getVisibilityData['analysisReport']['els']['defaults']['completed_responses_only'] || false;
          this.controls[4]['subControls'][14]['subControls'][1].value = this.getVisibilityData['analysisReport']['els']['defaults']['completed_responses_all'] || false;
          // Spss Report 
          if(!this.controls[3].hidden) this.controls[3].value =  this.getVisibilityData['analysisReport']['els']['defaults']['spss'] == '1' ? true : false;
          this.controls[6].value =  this.getVisibilityData['analysisReport']['els']['defaults']['exclude_open_end_question'] ? false : true;
        }
      }

      if(this.getVisibilityData?.funnelReport && this.getVisibilityData?.funnelReport['show']){
        this.controls[1].value = this.getVisibilityData['funnelReport']['show'];
      }

      if(this.getVisibilityData?.quotaReport && this.getVisibilityData?.quotaReport['show']){
        this.controls[2].value = this.getVisibilityData['quotaReport']['show'];
      }

      if(this.getVisibilityData['schedule'] && this.getVisibilityData['schedule']['show']){
        this.controls[5].value = this.getVisibilityData['schedule']['show'];
        this.scheduleRawDataObj = this.getVisibilityData['schedule']['els'];
      }

      



      // Miraj Code 
      this.setNewDefaultController();
    }
  }



  setNewDefaultController(){
    if(Object.keys(this.getVisibilityData).length){
      // Report View S
      if((this.getVisibilityData['funnelReport-beta'] && this.getVisibilityData['funnelReport-beta']['show']) || (this.getVisibilityData['utmReport-beta'] && this.getVisibilityData['utmReport-beta']['show']) ||  (this.getVisibilityData['termReport-beta'] && this.getVisibilityData['termReport-beta']['show']) || this.getVisibilityData?.biReport['show']){
        this.newdefaultControls[0]['value'] = true;
        if(this.getVisibilityData['funnelReport-beta'] && this.getVisibilityData['funnelReport-beta']['show']){
          this.newdefaultControls[0]['subControls'][0]['value'] = this.getVisibilityData['funnelReport-beta']['show'];
        }
        if(this.getVisibilityData['utmReport-beta'] && this.getVisibilityData['utmReport-beta']['show']){
          this.newdefaultControls[0]['subControls'][1]['value'] = this.getVisibilityData['utmReport-beta']['show'];
        }
        if(this.getVisibilityData['termReport-beta'] && this.getVisibilityData['termReport-beta']['show']){
          this.newdefaultControls[0]['subControls'][2]['value'] = this.getVisibilityData['termReport-beta']['show'];
        }
        if(this.getVisibilityData?.biReport['show']){
          this.newdefaultControls[0]['subControls'][3]['value'] = this.getVisibilityData['biReport']['show'];
        }
      }

      // Survey Properties Section
      if(this.getVisibilityData?.survey['show'] || (this.getVisibilityData['dairy-survey'] && this.getVisibilityData['dairy-survey']['show']) || ( this.getVisibilityData['survey-preview'] && this.getVisibilityData['survey-preview']['show'])){
        this.newdefaultControls[1]['value'] = true;
        if(this.getVisibilityData?.survey['show']){
          this.newdefaultControls[1]['subControls'][0]['value'] = this.getVisibilityData['survey']['show'];
        }
        if(this.getVisibilityData['dairy-survey'] && this.getVisibilityData['dairy-survey']['show']){
          this.newdefaultControls[1]['subControls'][1]['value'] = this.getVisibilityData['dairy-survey']['show'];
        }
        if(this.getVisibilityData['survey-preview'] && this.getVisibilityData['survey-preview']['show']){
          this.newdefaultControls[1]['subControls'][2]['value'] = this.getVisibilityData['survey-preview']['show'];
        }
      }

      // Misc Section 
      if(this.getVisibilityData?.panelList['show'] || this.getVisibilityData?.billAnalysis['show'] || this.getVisibilityData?.imageSearch['show'] || this.getVisibilityData?.analysisReport['show'] || this.getVisibilityData?.trueFace['show']) {
        this.newdefaultControls[2]['value'] = true;
        if(this.getVisibilityData?.panelList['show']){
          this.newdefaultControls[2]['subControls'][0]['value'] = this.getVisibilityData['panelList']['show'];
        }
        if(this.getVisibilityData?.billAnalysis['show']){
          this.newdefaultControls[2]['subControls'][1]['value'] = this.getVisibilityData['billAnalysis']['show'];
        }
        if(this.getVisibilityData?.imageSearch['show']){
          this.newdefaultControls[2]['subControls'][2]['value'] = this.getVisibilityData['imageSearch']['show'];
        }
        if(this.getVisibilityData?.analysisReport['show']){
          this.newdefaultControls[2]['subControls'][3]['value'] = this.getVisibilityData['analysisReport']['show'];
        }
        if(this.getVisibilityData?.trueFace['show']){
          this.newdefaultControls[2]['subControls'][4]['value'] = this.getVisibilityData['trueFace']['show'];
        }
      }

      // Superset Dashboard Section
      if(this.getVisibilityData?.superset){
        let supersetControl = this.newdefaultControls.find((control) => control.name === 'Superset Dashboard');
        if(supersetControl){
          supersetControl.value = this.getVisibilityData['superset']['show'] || false;
          let supersetEls = this.getVisibilityData['superset']['els'];
          if(supersetEls && Object.keys(supersetEls).length > 0){
            supersetControl.subControls.forEach((sub: any) => {
              if(supersetEls[sub.key]){
                sub.value = supersetEls[sub.key].show || false;
              }
            });
          }
        }
      }
    }
  }

  // set Controls to add controls value to "setStudyVisibility" request
  setControls(){
    this.assignVisibility();

      // Performance Tracker
      this.getVisibilityData['performaceTracker']['show'] = this.controls[0].value;

        // Performance Tracker Optional Control 
        this.getVisibilityData['delays']['delay'] = this.controls[0]['optionalControl'][0].value;
        this.getVisibilityData['delays']['delayCount'] = (this.controls[0]['optionalControl'][0].value == true ? this.controls[0]['optionalControl'][0].hours : 2);

        // Performance Tracker Sub Control
        this.getVisibilityData['performaceTracker']['els']['avgResponse'] = this.controls[0]['subControls'][0].value;
        this.getVisibilityData['performaceTracker']['els']['dropOff'] = this.controls[0]['subControls'][1].value;
        this.getVisibilityData['performaceTracker']['els']['terminations'] = this.controls[0]['subControls'][2].value;
        this.getVisibilityData['performaceTracker']['els']['responses'] = this.controls[0]['subControls'][3].value;
        this.getVisibilityData['performaceTracker']['els']['daysLeft'] = this.controls[0]['subControls'][4].value;
        this.getVisibilityData['performaceTracker']['els']['quotaCount'] = this.controls[0]['subControls'][5].value;
        this.getVisibilityData['performaceTracker']['els']['quotas'] = this.controls[0]['subControls'][6].value;
        this.getVisibilityData['performaceTracker']['els']['resRateGraph'] = this.controls[0]['subControls'][7].value;
        this.getVisibilityData['performaceTracker']['els']['incidenceRate'] = this.controls[0]['subControls'][8].value;
        this.getVisibilityData['performaceTracker']['els']['reqResponse'] = this.controls[0]['subControls'][9].value;
        // this.getVisibilityData['performaceTracker']['els']['medianLoi'] = this.controls[0]['subControls'][10].value;
        // this.getVisibilityData['performaceTracker']['els']['averageLoi'] = this.controls[0]['subControls'][11].value;

      //Download Report
      this.getVisibilityData['analysisReport']['els']['downloadReport'] = this.controls[4].value;
      this.getVisibilityData['analysisReport']['els']['rldReport'] = this.controls[4]['subHeaders'][0].value;
      this.getVisibilityData['analysisReport']['els']['spssReport'] = this.controls[4]['subHeaders'][1].value;
      if(!this.getVisibilityData['analysisReport']['els']['rldReport'] && !this.getVisibilityData['analysisReport']['els']['spssReport']){
        this.getVisibilityData['analysisReport']['els']['rldReport'] = true;
      }
      
  
      //Download Report Sub Controls
      // this.getVisibilityData['analysisReport']['els']['defaults']['company_data'] = this.controls[4]['subControls'][0].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['phone_number'] = this.controls[4]['subControls'][1].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['weblink'] = this.controls[4]['subControls'][2].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['survey_dates'] = this.controls[4]['subControls'][3].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['geo_location'] = this.controls[4]['subControls'][4].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['recruiter'] = this.controls[4]['subControls'][5].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['age'] = this.controls[4]['subControls'][6].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['city'] = this.controls[4]['subControls'][7].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['gender'] = this.controls[4]['subControls'][8].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['sec'] = this.controls[4]['subControls'][9].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['UTM'] = this.controls[4]['subControls'][10].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['ip'] = this.controls[4]['subControls'][11].value;
      // let report_type = this.controls[4]['subControls'][12]['subControls'].find(r=> r.value);
      // if(report_type) {
      //   this.getVisibilityData['analysisReport']['els']['defaults']['alter_report_type'] = report_type.key;
      // }
      // this.getVisibilityData['analysisReport']['els']['defaults']['completed_responses_only'] = this.controls[4]['subControls'][13]['subControls'][0].value;
      // this.getVisibilityData['analysisReport']['els']['defaults']['completed_responses_all'] = this.controls[4]['subControls'][13]['subControls'][1].value;

      this.getVisibilityData['analysisReport']['els']['defaults']['company_data'] = this.controls[4]['subControls'][0].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['include_concept_headers'] = this.controls[4]['subControls'][1].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['phone_number'] = this.controls[4]['subControls'][2].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['weblink'] = this.controls[4]['subControls'][3].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['survey_dates'] = this.controls[4]['subControls'][4].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['geo_location'] = this.controls[4]['subControls'][5].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['recruiter'] = this.controls[4]['subControls'][6].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['age'] = this.controls[4]['subControls'][7].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['city'] = this.controls[4]['subControls'][8].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['gender'] = this.controls[4]['subControls'][9].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['sec'] = this.controls[4]['subControls'][10].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['UTM'] = this.controls[4]['subControls'][11].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['ip'] = this.controls[4]['subControls'][12].value;
      let report_type = this.controls[4]['subControls'][13]['subControls'].find(r=> r.value);
      if(report_type) {
        this.getVisibilityData['analysisReport']['els']['defaults']['alter_report_type'] = report_type.key;
      }
      this.getVisibilityData['analysisReport']['els']['defaults']['completed_responses_only'] = this.controls[4]['subControls'][14]['subControls'][0].value;
      this.getVisibilityData['analysisReport']['els']['defaults']['completed_responses_all'] = this.controls[4]['subControls'][14]['subControls'][1].value;


      // Report View Section
      this.getVisibilityData['funnelReport-beta']['show'] = this.newdefaultControls[0]['subControls'][0].value // Funnel Beta Report
      this.getVisibilityData['utmReport-beta']['show'] = this.newdefaultControls[0]['subControls'][1].value //    UTM Beta Report
      this.getVisibilityData['termReport-beta']['show'] = this.newdefaultControls[0]['subControls'][2].value // Term Beta Report
      this.getVisibilityData['biReport']['show'] = this.newdefaultControls[0]['subControls'][3].value  //BI Report

      // Survey Properties Section
      this.getVisibilityData['survey']['show'] = this.newdefaultControls[1]['subControls'][0].value // Survey
      this.getVisibilityData['dairy-survey']['show'] = this.newdefaultControls[1]['subControls'][1].value // Dairy-Survey
      this.getVisibilityData['survey-preview']['show'] = this.newdefaultControls[1]['subControls'][2].value // Survey Preview

      // Misc Section 
      this.getVisibilityData['billAnalysis']['show'] = this.newdefaultControls[2]['subControls'][1].value; //Bill Analysis
      this.getVisibilityData['panelList']['show'] = this.newdefaultControls[2]['subControls'][0].value // Panel List
      this.getVisibilityData['imageSearch']['show'] = this.newdefaultControls[2]['subControls'][2].value //Image Search Panel
      this.getVisibilityData['analysisReport']['show'] = this.newdefaultControls[2]['subControls'][3].value; //Analysis Report
      this.getVisibilityData['trueFace']['show'] = this.newdefaultControls[2]['subControls'][4].value; //True Face Study



      // Funnel Quota Spss Report Check 
      this.getVisibilityData['funnelReport']['show'] = this.controls[1].value //funnel report
      this.getVisibilityData['quotaReport']['show'] = this.controls[2].value  //Quota Report
      if(!this.controls[3].hidden) this.getVisibilityData['analysisReport']['els']['defaults']['spss'] = this.controls[3].value == true  ? 1 : 0; //Spss Reportdefaults
      this.getVisibilityData['analysisReport']['els']['defaults']['exclude_open_end_question'] = !this.controls[6].value; //Exclude Open End Question


      // Shedule Raw Data (RLD) Section

      this.getVisibilityData['schedule']['show'] = this.controls[5].value;
      this.getVisibilityData['schedule']['els'] = this.scheduleRawDataObj;

      // Superset Dashboard Section
      let supersetControl = this.newdefaultControls.find((control) => control.name === 'Superset Dashboard');
      if(supersetControl){
        this.getVisibilityData['superset'] = this.getVisibilityData['superset'] || {show: false, els: {}};
        // Check if any subControl is enabled - if none are, set show to false
        const hasEnabledSubControl = supersetControl.subControls.some((sub: any) => sub.value === true);
        this.getVisibilityData['superset']['show'] = supersetControl.value && hasEnabledSubControl;
        this.getVisibilityData['superset']['els'] = {};
        supersetControl.subControls.forEach((sub: any) => {
          this.getVisibilityData['superset']['els'][sub.key] = {
            show: sub.value,
            label: sub.name,
            uuid: sub.uuid,
            desc: sub.desc
          };
        });
      }
  }

  assignVisibility(){
    // this.getVisibilityData = JSON.stringify({"performaceTracker":{"show":false,"els":{"avgResponse":false,"incidenceRate":false,"reqResponse":false,"dropOff":false,"terminations":false,"averageLoi":false,"medianLoi":false,"responses":false,"daysLeft":false,"quotaCount":false,"quotas":false,"resRateGraph":false}},"delays":{"delay":false,"delayCount":0},"panelList":{"show":false},"billAnalysis":{"show":false}, "biReport":{"show":false},"quotaReport":{"show":false},"funnelReport":{"show":false},"analysisReport":{"show":false,"els":{"downloadReport":false,"defaults":{"company_data":false,"completed_responses_only":false,"phone_number":false,"weblink":false,"survey_dates":false,"sec":false,"gender":false,"age":false,"city":false,"geo_location":false,"recruiter":false}}},"imageSearch":{"show":false},"trueFace":{"show":false},"survey":{"show":false},'dairy-survey':{"show":false}});
    // this.getVisibilityData = JSON.parse(this.getVisibilityData);
    this.getVisibilityData = JSON.stringify(
      {
        "performaceTracker":{"show":false,"els":{"avgResponse":false,"incidenceRate":false,"reqResponse":false,"dropOff":false,"terminations":false,"averageLoi":false,"medianLoi":false,"responses":false,"daysLeft":false,"quotaCount":false,"quotas":false,"resRateGraph":false}},
        "delays":{"delay":false,"delayCount":0},
        "panelList":{"show":false},
        "billAnalysis":{"show":false},
        "biReport":{"show":false},
        "quotaReport":{"show":false},
        "funnelReport":{"show":false},
        "analysisReport":{"show":false,"els":{"downloadReport":false,"defaults":{"survey_dates_research":true,"company_data":false,"phone_number":false,"weblink":false,"survey_dates":false,"sec":false,"gender":false,"age":false,"city":false,"geo_location":false,"recruiter":false,'spss':false,'exclude_open_end_question':false,'UTM':false, "alter_report_type": false, "completed_responses_only": false, "completed_responses_all": false}}},
        "imageSearch":{"show":false},
        "trueFace":{"show":false},
        "survey":{"show":false},
        "dairy-survey":{"show":false},
        "survey-preview":{"show":false},
        // 2369
        "funnelReport-beta":{"show":false},
        "utmReport-beta":{"show":false},
        "termReport-beta":{"show":false},
        "schedule":{"show":false,els:{start_date:"",end_date:"",month_date:'',week_day:'1',repeat_type:'Daily',timeSlot:[{"hours":"","minutes":""}],sendTo:[]}},
        "superset":{"show":false,"els":{}}
      });
      this.getVisibilityData = JSON.parse(this.getVisibilityData);
  }
  

  getResponseDataQuota(){

    this.panelService.getResponceDataQuota(this.studyId).subscribe((data) => {

      if (data.status == 1 && data.result) {
     
      
         this.detailsName = data.result['details']['name'].length > 80 ? data.result['details']['name'].slice(0,80)+ '...': data.result['details']['name'];

         this.detailsNameFull=data.result['details']['name'];

         if(data.result['projectOfStudies'])
         {
         this.rootProjectName=data.result['projectOfStudies']['name'];
         this.rootProjectUrl=data.result['projectOfStudies']['uuid'];
       }


    } 
    },
    (error) => {
      console.error(error);
        if (error.status === 401) {
          this.errorText = 'User is not authorised';
          this.isError = true;
      //    this.isData = true;
        }
      });
  }



  recruiterMenu(type) {
    if (type === 'all') {
      this.router.navigate(['/home/projects']);
    }else{
      this.router.navigate(['/home/projects', this.rootProjectUrl]);
    }
  }


  toggleNewdefaultControls(index:any){
    this.newdefaultControls[index].value = ! this.newdefaultControls[index].value;
  }

  toggleNewSubdefaultControls(index:number,subIndex:number){
    this.newdefaultControls[index]['subControls'][subIndex].value = !this.newdefaultControls[index]['subControls'][subIndex].value
  }

  // addMoreTimeSlot(ind){
  //   let slot = this.scheduleRawDataObj.timeSlot[ind];
  //   if(slot.hours && slot.minutes){
  //     this.scheduleRawDataObj.timeSlot.push({hours:'',minutes:''});
  //   }else{
  //     this.notifier.notify('error','Please fill the current time slot');
  //   }
  // }

  // deleteTimeSlot(ind){
  //   this.scheduleRawDataObj.timeSlot.splice(ind,1);
  //   if(this.scheduleRawDataObj.timeSlot.length == 0){
  //     this.scheduleRawDataObj.timeSlot.push({hours:'',minutes:''});
  //   }
  // }

  // onEnterPressSendTo(event: KeyboardEvent) {
  //   const input = (event.target as HTMLInputElement).value.trim();
  //   if (event.key === 'Enter' && this.validateEmail(input)) {
  //     this.scheduleRawDataObj.sendTo.push(input);
  //     (event.target as HTMLInputElement).value = '';
  //   } else if (event.key === 'Enter') {
  //     this.notifier.notify('error', 'Please enter a valid email address');
  //   }
  // }

  // validateEmail(email: string): boolean {
  //   const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  //   return emailPattern.test(email);
  // }

  // deleteSendTo(ind){
  //   this.scheduleRawDataObj.sendTo.splice(ind,1);
  // }

  onScheduleRepeatTypeChange(event){
    if(event.value === 'Weekly'){
      delete this.scheduleRawDataObj.month_date
      this.scheduleRawDataObj.week_day = '1';
    }
    if(event.value === 'Monthly'){
      delete this.scheduleRawDataObj.week_day
    }
  }

  


}
